import UserContext from "Context/UserProvider";
import { useContext, useEffect, useRef, useState } from "react";
import toast from 'react-hot-toast';
import { useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import { useApiService } from "../../services/ApiService/ApiService";

interface OptionType {
    label: string;
    value: string;
    name: string;
}
function PowerPurchaseAgreementPage(props: any) {

    const [loading, setLoading] = useState(true);
    const { userInfo, setUserInfo } = useContext(UserContext);
    const [parameter, setParameter] = useState({}) as any;
    const location = useLocation();
    const params = location.state as any;
    const currentInput = useRef() as any;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isError, setIsError] = useState(false);
    const { fetchWithAuth } = useApiService();

    const [numberOfVehicles, setNumberOfVehicles] = useState<number | null>(null);
    const [chargesPerWeek, setChargesPerWeek] = useState<number | null>(null);
    const [averageChargeSize, setAverageChargeSize] = useState<number | null>(null);
    const [monthlyRequirementKWh, setMonthlyRequirementKWh] = useState<number | null>(null);

    const [agreement, setAgreement] = useState([]) as any

    useEffect(() => {
        fetchPPA();

    }, []);

    async function fetchPPA() {
        setLoading(true);
        try {
            const response = await fetchWithAuth('/cpo/ppa/get', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    businessUuid: userInfo.businessUuid
                })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch PPA data');
            }

            const res_json = await response.json();
            setAgreement(res_json.agreement);
        } catch (error) {
            console.error('Error fetching PPA data:', error);
            toast.error('Failed to load PPA data');
        } finally {
            setLoading(false);
        }
    }

    async function saveChargingPartnerRateCard() {
        setIsDisabled(true);
        try {
            const chargingPartnerRateCard = {
                energyCostAcSinglePhaseGbpPerKWhOffPeak: Number(parameter.energyCostAcSinglePhaseGbpPerKWhOffPeak),
                energyCostAcThreePhaseGbpPerKWhOffPeak: Number(parameter.energyCostAcThreePhaseGbpPerKWhOffPeak),
                energyCostDcGbpPerKWhOffPeak: Number(parameter.energyCostDcGbpPerKWhOffPeak),
                energyCostAcSinglePhaseGbpPerKWhPeak: Number(parameter.energyCostAcSinglePhaseGbpPerKWhPeak),
                energyCostAcThreePhaseGbpPerKWhPeak: Number(parameter.energyCostAcThreePhaseGbpPerKWhPeak),
                energyCostDcGbpPerKWhPeak: Number(parameter.energyCostDcGbpPerKWhPeak),
                name: parameter.name,
                allowanceKWh: parameter.allowanceKWh
            };

            const response = await fetchWithAuth('/charging-partner/rate-card/save', {
                method: 'POST',
                body: JSON.stringify({
                    uuid: userInfo.uuid,
                    chargingPartnerRateCard,
                    chargingPartnerRateCardUuid: parameter.uuid,
                    businessUuid: userInfo.businessUuid
                })
            });

            if (!response.ok) {
                const res_json = await response.json();
                throw new Error(res_json.code || 'Failed to save rate card');
            }

            toast.success('Rate Card Save Successful', {
                position: 'bottom-center',
                duration: 5000,
            });
        } catch (error) {
            console.error('Error saving rate card:', error);
            const errorMessage = error instanceof Error ? error.message : 'An error occurred whilst saving this rate card.';
            toast.error(errorMessage, {
                position: 'bottom-center',
                duration: 5000,
            });
        } finally {
            setIsDisabled(false);
        }
    }


    return (
        <>
            {loading ? (
                <>Loading ...</>
            ) : (
                agreement == null ? (
                    <div><span>No Power Purchase Agreement has been set up - please click <Link to="/agree/power-purchase-agreement/create">Create PPA</Link> to start</span></div>
                ) : (

                    <div className="container-fluid g-0">
                        <div className="row gy-2">

                            <div className="col-xs-12 col-md-6 col-xl-4">
                                <div className="dashboard-card">
                                    <div className="dashboard-card-title">
                                        <span className="icon material-symbols-outlined">view_timeline</span>
                                        Power Requirements                              </div>
                                    <div
                                        className="dashboard-card-content"
                                        style={{ gap: 20 }}>
                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Number of Vehicles :
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    {agreement.numberOfVehicles}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Charges Per Week :
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    {agreement.chargesPerWeek}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Average Size of Charge:
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    {agreement.averageChargeSizeInKWh} kW/h
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6 col-xl-4">
                                <div className="dashboard-card">
                                    <div className="dashboard-card-title">
                                        <span className="icon material-symbols-outlined">view_timeline</span>
                                        Power Purchase Agreement                              </div>
                                    <div
                                        className="dashboard-card-content"
                                        style={{ gap: 20 }}>

                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Start Date :
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    {agreement.startDate}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Monthly kW/h commitment :
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    {agreement.monthlyCommitmentInKWh.toFixed(2)} kW/h
                                                </span>
                                            </div>
                                        </div>
                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Monthly Purchase commitment :
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    £{agreement.monthlyCommitmentInGbp.toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6 col-xl-4">
                                <div className="dashboard-card">
                                    <div className="dashboard-card-title">
                                        <span className="icon material-symbols-outlined">view_timeline</span>
                                        Provider                              
                                    </div>
                                    <div
                                        className="dashboard-card-content"
                                        style={{ gap: 20 }}>

                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Charge Point Operator :
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    {agreement.chargePointOperator.name}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Product
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    {agreement.rateCardName}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="box-info">
                                            <span
                                                className="item"
                                                style={{ width: 300 }}>
                                                Price per kW/h
                                            </span>
                                            <div style={{ display: "flex", alignItems: "center", textAlign: "center", width: 180 }}>
                                                <span
                                                    className="item"
                                                    style={{ width: 300 }}>
                                                    £{agreement.ppaPricePerKWh.toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            )}
        </>
    );
}

export default PowerPurchaseAgreementPage;
